import * as React from 'react';

function IrLiftsIcon({ color = '#545454', ...props }) {
	return (
		<svg width={18} height={18} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M9.5 14L12 16L14.5 14M9.5 10L12 8L14.5 10M4 19L4 5C4 3.89543 4.89543 3 6 3L18 3C19.1046 3 20 3.89543 20 5L20 19C20 20.1046 19.1046 21 18 21L6 21C4.89543 21 4 20.1046 4 19Z'
				stroke={color}
				stroke-width='2'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<rect x='15.3916' y='0.994141' width='7.80462' height='7.64024' rx='1.5' fill={color} />
			<path
				d='M17.711 2.41232V6.99414H16.7423V2.41232H17.711ZM18.508 6.99414V2.41232H20.3156C20.6617 2.41232 20.957 2.47422 21.2016 2.59801C21.4477 2.72031 21.6349 2.89407 21.7631 3.11928C21.8929 3.343 21.9578 3.60625 21.9578 3.90902C21.9578 4.21328 21.8921 4.47504 21.7609 4.69428C21.6296 4.91204 21.4395 5.07908 21.1904 5.19542C20.9428 5.31175 20.643 5.36992 20.291 5.36992H19.0807V4.59137H20.1344C20.3194 4.59137 20.473 4.56602 20.5953 4.51531C20.7176 4.4646 20.8086 4.38853 20.8682 4.28711C20.9294 4.18569 20.96 4.05966 20.96 3.90902C20.96 3.75689 20.9294 3.62862 20.8682 3.52422C20.8086 3.41982 20.7169 3.34077 20.5931 3.28707C20.4708 3.23189 20.3164 3.2043 20.13 3.2043H19.4767V6.99414H18.508ZM20.9823 4.90906L22.1211 6.99414H21.0517L19.9376 4.90906H20.9823Z'
				fill={color === 'white' ? '#545454' : 'white'}
			/>
		</svg>
	);
}

export default IrLiftsIcon;
